import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

import { store } from '../store';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function fetchClaims(relative = 'all', authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/care/claims?relativeId=${relative}`,
    headers,
  });
}

export function fetchClaimSummary(claimId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/reimbursements/${claimId}/claim-status`,
    headers,
  });
}

export function fetchClaimStatusSummaryV2(claimId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/reimbursements/v2/${claimId}/claim-status-details`,
    headers,
  });
}

export function fetchClaimSummaryV2(claimId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/reimbursements/v2/${claimId}/claim-status`,
    headers,
  });
}

export function uploadDocuments(body, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/reimbursements/v2/upload-documents`,
    headers,
    data: body,
  });
}

export function getFeedbackDetails(claimId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/reimbursements/v2/feedback-details?reimbursementId=${claimId}`,
    headers,
  });
}

export function postFeedbackDetails(formData, authToken) {
  const headers = { authorization: authToken };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/reimbursements/v2/feedback`,
    headers,
    data: formData,
  });
}

export function knowMoreDetails(claimId, authToken) {
  const headers = { authorization: authToken };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/reimbursements/v2/documents-verified-view-more?reimbursementId=${claimId}`,
    headers,
  });
}

export function requestDoctorCall(consultationId, requestType, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/opd/connectionRequest/${consultationId}`,
    headers,
    data: {
      requestType,
    },
  });
}
export function fetchGmcDocuments(authToken, claimId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/gmc/${claimId}/claim-documents`,
    headers,
  });
}

export function submitGmcClaimDocs(authToken, body) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/gmc/claim-documents`,
    headers,
    data: body,
  });
}
